import template from "./template.html";
import config from "../config";

export default function (editor) {
  const { DomComponents, BlockManager } = editor;

  // Общие defaults для редактируемых text-узлов (вопрос/ответ).
  const editableText = {
    editable: true,
    selectable: true,
    hoverable: true,
    draggable: false,
    removable: false,
    copyable: false,
  };

  DomComponents.addType("solo-landing-faq-accordion", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("solo-landing-faq-accordion"),
    model: {
      defaults: {
        draggable: true,
        removable: true,
        selectable: true,
        hoverable: true,
        stylable: ["background-color"],
      },
    },
  });
  DomComponents.addType("solo-landing-faq-accordion-item", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("solo-landing-faq-accordion__item"),
    model: {
      defaults: {
        removable: true,
        selectable: true,
        copyable: true,
        hoverable: true,
      },
    },
  });
  // Текст вопроса и ответа — редактируемые text-компоненты (наследуют RTE).
  // Регистрируем явно, иначе вложенность в невыделяемые контейнеры мешает
  // двойному клику для входа в режим редактирования.
  DomComponents.addType("solo-landing-faq-accordion-question", {
    extend: "text",
    isComponent: (el: HTMLElement) =>
      el.classList && el.classList.contains("solo-landing-faq-accordion__question"),
    model: {
      defaults: { ...editableText },
    },
  });
  DomComponents.addType("solo-landing-faq-accordion-answer", {
    extend: "text",
    isComponent: (el: HTMLElement) =>
      el.classList && el.classList.contains("solo-landing-faq-accordion__answer-text"),
    model: {
      defaults: { ...editableText },
    },
  });

  BlockManager.add("solo-landing-faq-accordion", {
    ...config,
    label: "FAQ (accordion)",
    content: template,
  });
}
